import axios from 'axios';

import { TOKEN_KEY } from './TokenManager';
import { CLIENT_ID, SECRET_KEY } from './index';
import { baseURL } from './url';
import { decrypt, encrypt } from './encodingdecoding';

let refreshPromise = null;

const getNewAuthToken = () => {
	if (refreshPromise) return refreshPromise;
	const isAdminRoute = window.location.pathname.includes('/admin');
	refreshPromise = (async () => {
		try {
			const formData = {
				client_id: isAdminRoute
					? encrypt(CLIENT_ID)
					: localStorage.getItem('clientid'),
				secret_key: isAdminRoute
					? encrypt(SECRET_KEY)
					: localStorage.getItem('clientsecret'),
			};
			const response = await axios.post(
				`${baseURL}fulfilmentTokenStaging`,
				formData,
				{
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
				},
			);
			const token = response?.data?.message?.data?.access_token;

			localStorage.setItem(TOKEN_KEY, token);
			return token;
		} catch (err) {
			throw err;
		} finally {
			refreshPromise = null;
		}
	})();

	return refreshPromise;
};

export default getNewAuthToken;
